import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import BoxFooter from './BoxFooter';
import AvailabilityPlanning from './planning/AvailabilityPlanning';
import Card from '../common/Card';
import DateFormat from '../common/format/DateFormat';
import {fetchDealerPlanningConfiguration} from '../../actions/planningConfigurationActions';
import {selectPlanningConfiguration} from '../../selectors/planningConfigurationSelector';
import Intervention from '../../services/Intervention';

import './AppointmentDate.css';

class AppointmentDate extends Component {

  static propTypes = {
    dispatchFetchDealerPlanningConfiguration: PropTypes.func.isRequired,
    hidePlanningModal: PropTypes.func.isRequired,
    showPlanningModal: PropTypes.func.isRequired,
  }

  componentDidMount() {
    this.props.dispatchFetchDealerPlanningConfiguration();
  }

  render() {
    const {intl: {formatMessage}, showModal, canWrite, mainServices, planningConfiguration} = this.props;
    const {intervention, intervention: {journey: {properties: {reception: {dropOff = {}, pickUp = {}} = {}} = {}} = {}}} = this.props;

    const startDateLayout = dropOff.duringWorkingHours === false ? "dateOnly" : "dateTimeLong";
    const endDateLayout = pickUp.duringWorkingHours === false ? "dateOnly" : "dateTimeLong";

    const planningChecked = Intervention.isConfirmed(intervention);

    return (
      <Card
        title={formatMessage({id: 'appointment.detail.dates.title'})}
        onAlert={!planningChecked}
        footer={canWrite &&
          <BoxFooter>
            <button type="button" className="btn btn-sm btn-primary" onClick={this.props.showPlanningModal}>{formatMessage({id: 'appointment.detail.dates.check-planning'})}</button>
          </BoxFooter>
        }>
        <div className={"d-flex"}>
          <span className="txt-muted">{formatMessage({id: 'appointment.detail.dates.start'})}:</span>
          {intervention.startDate && <DateFormat className="ml-1" layout={startDateLayout} date={intervention.startDate}/>}
        </div>
        <span className="txt-muted">{formatMessage({id: 'appointment.detail.dates.end'})}:</span>
        {intervention.endDate && <DateFormat className="ml-1" layout={endDateLayout} date={intervention.endDate}/>}

        {/* prevents component to be loaded */}
        {showModal && <AvailabilityPlanning visible={showModal} onClose={this.props.hidePlanningModal} mainServices={mainServices} intervention={intervention} planningConfiguration={planningConfiguration}/>}
      </Card>
    );
  }
}

const mapStateToProps = state => ({
  planningConfiguration: selectPlanningConfiguration(state),
  showModal: state.fetchIntervention.showModal
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchDealerPlanningConfiguration: () => dispatch(fetchDealerPlanningConfiguration()),
  hidePlanningModal: () => dispatch({type: "HIDE_CONFIRM_INTERVENTION_MODAL"}),
  showPlanningModal: () => dispatch({type: "SHOW_CONFIRM_INTERVENTION_MODAL"})
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(AppointmentDate))
